module.exports = __webpack_public_path__ + "img/support-img.4149dea8.png";